(function (app, ng) {
    app.component("startTour",
        {
            templateUrl: "App/Components/TourModal/tour.component-template.html",
            controller: tourComponentController,
            bindings: {
                tourName: "@",
                onTourClosedFn: "&"
            }
        });

    tourComponentController.$inject = ["featureToggleService", "$mdDialog", "tour", "tours"];
    function tourComponentController(featureToggleService, $mdDialog, tour, tours) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
            });

        $ctrl.startTour = function (tourName) {
            return tour.createTour(tours.getTour(tourName));
        };

        $ctrl.close = function ($event) {
            $mdDialog.cancel($event);
        };

        $ctrl.$onInit = function () {
            $ctrl.environment = featureToggleService.checkEnv();
        };
    }

})(window.app, window.angular); //jshint ignore:line